function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 16 3 C 14.895431 3 14 3.8954305 14 5 C 14 5.0852793 14.020891 5.1675298 14.03125 5.25 C 10.573943 6.133638 8 9.273843 8 13 L 8 22 C 8 22.56503 7.5650302 23 7 23 L 6 23 L 6 25 L 13.1875 25 C 13.073239 25.315761 13 25.647008 13 26 C 13 27.64501 14.35499 29 16 29 C 17.64501 29 19 27.64501 19 26 C 19 25.647008 18.926761 25.315761 18.8125 25 L 26 25 L 26 23 L 25 23 C 24.43497 23 24 22.56503 24 22 L 24 13.28125 C 24 9.5227364 21.490109 6.1735161 17.96875 5.25 C 17.979109 5.1675298 18 5.0852793 18 5 C 18 3.8954305 17.104569 3 16 3 z M 15.5625 7 C 15.70799 6.9894429 15.851727 7.0001055 16 7 C 16.063546 6.9999548 16.12349 6.9980784 16.1875 7 C 19.454262 7.098037 22 9.9618599 22 13.28125 L 22 22 C 22 22.352983 22.073236 22.684242 22.1875 23 L 9.8125 23 C 9.9267636 22.684242 10 22.352983 10 22 L 10 13 C 10 9.8240913 12.44485 7.2262234 15.5625 7 z M 16 25 C 16.564128 25 17 25.435872 17 26 C 17 26.564128 16.564128 27 16 27 C 15.435872 27 15 26.564128 15 26 C 15 25.435872 15.435872 25 16 25 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/appointment-remainders.9a5a1ef3.svg";
export { SvgComponent as ReactComponent };